import { render, staticRenderFns } from "./ContentPublish.vue?vue&type=template&id=54f237e9&scoped=true&"
import script from "./ContentPublish.vue?vue&type=script&lang=js&"
export * from "./ContentPublish.vue?vue&type=script&lang=js&"
import style0 from "./ContentPublish.vue?vue&type=style&index=0&id=54f237e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f237e9",
  null
  
)

export default component.exports